'ModMaint'.maint()
'Back'.action({act: 'cancel'})
'OK'.action({act: 'ok'})
'Save'.action({act: 'save'})
'Mod'.datatype()

'Main'.panel()
'builtInSpecname'.field({readOnly: true})
'status'.field({readOnly: true})
'errorMessage'.field({readOnly: true})

''.panel()

'Blueprint'.panel({fullWidth: true})
'blueprint'.field({jsEditor: true})

'ModMaint'.dynamicTitle(function() {
  let builtInSpec = this.callerCast(); if ( ! builtInSpec ) return
  return 'Modify ' + builtInSpec.name
})

'ModMaint'.substituteCast(async builtInSpec => {
  let mod = await 'Mod'.bringOrCreate({builtInSpecname: builtInSpec.name})
  await mod.refreshStatus()
  return mod
})

'status'.visibleWhen((maint, mod) => {
  return mod.errorMessage ? false : true
})

'errorMessage'.visibleWhen((maint, mod) => {
  return mod.errorMessage ? true : false
})
